import { Trans } from '@lingui/macro';
import { CircularProgress } from '@material-ui/core';
import CalleeInstructionsSection from './CalleeInstructionsSection';
import VoipAgentListPanel from './VoipAgentListPanel';
import { useVoipCallParticipants } from './UseVoipCallParticipants';
import TestFormSection from '../TestFormSection/TestFormSection';

export const VoipPulseCallParticipantsSection = () => {
    const {
        filterClasses,
        isLoading,
        callerAgent,
        calleeAgent,
        showCalleeInstructions,
        callerFilterText,
        setCallerFilterText,
        calleeFilterText,
        setCalleeFilterText,
        filteredCallerAgents,
        filteredCalleeAgents,
        selectedCallerId,
        selectedCalleeId,
        handleCallerSelect,
        handleCalleeSelect,
    } = useVoipCallParticipants();

    if (isLoading) {
        return (
            <TestFormSection title={<Trans>Call Participants</Trans>} addSpacer>
                <CircularProgress size={24} />
            </TestFormSection>
        );
    }

    return (
        <TestFormSection title={<Trans>Call Participants</Trans>} addSpacer>
            <div className={filterClasses.row}>
                {/* Caller column */}
                <div className={filterClasses.column}>
                    <VoipAgentListPanel
                        title={<Trans>Caller</Trans>}
                        agents={filteredCallerAgents}
                        filterText={callerFilterText}
                        onFilterChange={setCallerFilterText}
                        selectedId={selectedCallerId}
                        onSelect={handleCallerSelect}
                        classes={filterClasses}
                    />
                </div>

                {/* Callee column */}
                <div className={filterClasses.column}>
                    <VoipAgentListPanel
                        title={<Trans>Callee</Trans>}
                        agents={filteredCalleeAgents}
                        filterText={calleeFilterText}
                        onFilterChange={setCalleeFilterText}
                        selectedId={selectedCalleeId}
                        onSelect={handleCalleeSelect}
                        classes={filterClasses}
                    />

                    {/* Callee Instructions — shown only for call-manager pulse-to-pulse */}
                    {showCalleeInstructions && (
                        <CalleeInstructionsSection callerAgent={callerAgent} calleeAgent={calleeAgent} />
                    )}
                </div>
            </div>
        </TestFormSection>
    );
};
